import { SaveableCard } from "@jasper/forms";
import {
  Group,
  Select,
  SimpleGrid,
  Stack,
  Text,
  TextInput,
} from "@mantine/core";
import { withForm } from "../../../hooks/preferenceForm";
import { usePreferenceCardSave } from "../../../hooks/usePreferenceCardSave";
import { getDeliveryPreferenceDefaults } from "../deliveryPreferenceForm";

const OFFICES = ["Cabinet Lyon 6ᵉ · 14 rue Vendôme"];
const FLOORS = [
  "RDC · porte gauche",
  "RDC · porte droite",
  "1er étage",
  "2ᵉ étage",
];

export const OfficeDetailsPreferences = withForm({
  defaultValues: getDeliveryPreferenceDefaults(),
  render: function Render({ form }) {
    const { status, save } = usePreferenceCardSave(form, [
      "office",
      "floor",
      "deliveryDetails",
    ]);

    return (
      <SaveableCard
        title="Coordonnées du cabinet"
        description="Adresse utilisée pour les expéditions et les ramassages"
        status={status}
        onSave={save}
      >
        <Stack gap="s3">
          <SimpleGrid cols={2}>
            <Stack gap="s2">
              <Text variant="strong">Cabinet</Text>
              <form.Field name="office">
                {field => (
                  <Select
                    data={OFFICES}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
            <Stack gap="s2">
              <Text variant="strong">Étage / bâtiment</Text>
              <form.Field name="floor">
                {field => (
                  <Select
                    data={FLOORS}
                    value={field.state.value}
                    onChange={field.handleChange}
                  />
                )}
              </form.Field>
            </Stack>
          </SimpleGrid>
          <>
            <Group gap="s1">
              <Text variant="strong">Précisions de livraison</Text>
              <Text variant="strong" fw="400" c="var(--mantine-color-ink-4)">
                transmises au transporteur
              </Text>
            </Group>
            <form.Field name="deliveryDetails">
              {field => (
                <TextInput
                  value={field.state.value}
                  onChange={event => field.handleChange(event.target.value)}
                  onBlur={field.handleBlur}
                />
              )}
            </form.Field>
          </>
        </Stack>
      </SaveableCard>
    );
  },
});
